import {
  BILL_SIDEBAR_NODES,
  MAAS_SIDEBAR_NODES,
  MLOPS_SIDEBAR_NODES,
  navNodesToReactRouteItems,
} from '@trainkr/navigation'

export type RouteItem = {
  index?: number
  title: string
  msg?: string
  icon?: string
  path?: string
  permission?: string
  children?: RouteItem[]
  adminOnly?: boolean
  roles?: string[]
  type?: 'group'
}

export const routes = {
  home: [
    {
      index: 1,
      title: 'userCenter',
      icon: 'menu-dashboard',
      path: '/iaas/dashboard',
    },
  ],
  iaas: [
    {
      index: 20,
      title: 'compute',
      icon: 'menu-compute',
      children: [
        {
          title: 'instancesAndImages',
          type: 'group',
          children: [
            {
              title: 'vm',
              icon: 'cloud-machine',
              path: '/iaas/vminstance',
              permission: 'servers_list',
            },
            {
              title: 'baremetal',
              path: '/iaas/baremetal',
              permission: 'servers_list',
            },
            {
              title: 'instanceGroup',
              path: '/iaas/instancegroup',
              permission: 'instancegroups_list',
            },
            {
              title: 'serverTemplate',
              path: '/iaas/servertemplate',
              permission: 'servertemplates_list',
            },
            {
              title: 'scalingGroup',
              path: '/iaas/scalinggroup',
              permission: 'scalinggroups_list',
            },
            {
              title: 'webApp',
              path: '/iaas/webapp',
              permission: 'webapps_list',
            },
            {
              title: 'systemImage',
              path: '/iaas/image',
              permission: 'images_list',
            },
            {
              title: 'hostImage',
              path: '/iaas/host_image',
              permission: 'guestimages_list',
            },
          ],
        },
        {
          title: 'storageAndBackup',
          type: 'group',
          children: [
            { title: 'disk', path: '/iaas/disk', permission: 'disks_list' },
            {
              title: 'diskSnapshot',
              path: '/iaas/disk-snapshot',
              permission: 'snapshots_list',
            },
            {
              title: 'instanceSnapshot',
              path: '/iaas/instance-snapshot',
              permission: 'instance_snapshots_list',
            },
            {
              title: 'snapshotPolicy',
              path: '/iaas/snapshotpolicy',
              permission: 'snapshotpolicy_list',
            },
            {
              title: 'diskBackup',
              path: '/iaas/disk-backup',
              permission: 'diskbackups_list',
            },
            {
              title: 'instanceBackup',
              path: '/iaas/instance-backup',
              permission: 'instancebackups_list',
            },
          ],
        },
        {
          title: 'networkAndSecurity',
          type: 'group',
          children: [
            {
              title: 'secGroup',
              path: '/iaas/secgroup',
              permission: 'secgroups_list',
            },
            {
              title: 'subnet',
              path: '/iaas/network2',
              permission: 'networks_list',
            },
            {
              title: 'eip',
              path: '/iaas/eip2',
              permission: 'eips_list',
            },
            {
              title: 'tapService',
              path: '/iaas/tap-service',
              permission: 'tapservices_list',
            },
            {
              title: 'keypair',
              path: '/iaas/keypair',
              permission: 'keypairs_list',
            },
          ],
        },
        {
          title: 'resourceAndSchedule',
          type: 'group',
          children: [
            { title: 'sku', path: '/iaas/sku', permission: 'serverskus_list' },
            { title: 'host', path: '/iaas/host', permission: 'hosts_list' },
            {
              title: 'physicalMachine',
              path: '/iaas/physicalmachine',
              permission: 'hosts_list',
            },
            {
              title: 'gpu',
              path: '/iaas/gpu',
              permission: 'isolated_devices_list',
            },
            {
              title: 'schedTag',
              path: '/iaas/schedtag',
              permission: 'schedtags_list',
            },
            {
              title: 'schedPolicy',
              path: '/iaas/schedpolicy',
              permission: 'schedpolicies_list',
            },
            {
              title: 'dynamicSchedTag',
              path: '/iaas/dynamicschedtag',
              permission: 'dynamicschedtags_list',
            },
          ],
        },
        {
          title: 'recycleBin',
          type: 'group',
          children: [
            {
              title: 'serverRecovery',
              path: '/iaas/serverrecovery',
              permission: 'servers_list',
            },
            {
              title: 'diskRecovery',
              path: '/iaas/diskrecovery',
              permission: 'disks_list',
            },
            {
              title: 'imageRecovery',
              path: '/iaas/imagerecovery',
              permission: 'images_list',
            },
          ],
          permission: 'recyclebins_list',
        },
      ],
    },
    {
      index: 40,
      title: 'network',
      icon: 'menu-network',
      children: [
        {
          title: 'networkPlan',
          type: 'group',
          children: [
            {
              title: 'region',
              path: '/iaas/cloudregion',
              permission: 'areas_list',
            },
            { title: 'zone', path: '/iaas/zone', permission: 'zones_list' },
          ],
        },
        {
          title: 'baseNetwork',
          type: 'group',
          children: [
            {
              title: 'vpcInterconnect',
              path: '/iaas/vpc-network',
              permission: 'inter_vpc_networks_list',
            },
            {
              title: 'vpcPeer',
              path: '/iaas/vpc-peerconnect',
              permission: 'vpc_peering_connections_list',
            },
            {
              title: 'globalVpc',
              path: '/iaas/globalvpc',
              permission: 'network_globalvpcs_list',
            },
            { title: 'vpc', path: '/iaas/vpc', permission: 'vpcs_list' },
            {
              title: 'routeTable',
              path: '/iaas/routetable',
              permission: 'route_tables_list',
            },
            { title: 'wire', path: '/iaas/wire', permission: 'wires_list' },
            {
              title: 'subnet',
              path: '/iaas/network',
              permission: 'networks_list',
            },
          ],
        },
        {
          title: 'networkService',
          type: 'group',
          children: [
            { title: 'eip', path: '/iaas/eip', permission: 'eips_list' },
            {
              title: 'nat',
              path: '/iaas/nat',
              permission: 'natgateways_list',
            },
            {
              title: 'dns',
              path: '/iaas/dns-zone',
              permission: 'dns_zones_list',
            },
            {
              title: 'ipv6',
              path: '/iaas/ipv6-gateway',
              permission: 'ipv6_gateways_list',
            },
          ],
        },
        {
          title: 'networkSecurity',
          type: 'group',
          children: [
            {
              title: 'waf',
              path: '/iaas/waf',
              permission: 'waf_instances_list',
            },
          ],
        },
        {
          title: 'sshProxy',
          type: 'group',
          children: [
            {
              title: 'sshProxyNode',
              path: '/iaas/ssh-proxy',
              permission: 'sshproxy_node_list',
            },
            {
              title: 'sshProxyService',
              path: '/iaas/ssh-agent',
              permission: 'sshproxy_service_list',
            },
          ],
        },
        {
          title: 'lb',
          type: 'group',
          children: [
            {
              title: 'lbInstance',
              path: '/iaas/lb',
              permission: 'lb_loadbalancers_list',
            },
            {
              title: 'lbAcl',
              path: '/iaas/lbacl',
              permission: 'lb_loadbalanceracls_list',
            },
            {
              title: 'lbCert',
              path: '/iaas/lbcert',
              permission: 'lb_loadbalancercertificates_list',
            },
          ],
        },
        {
          title: 'lbCluster',
          type: 'group',
          children: [
            {
              title: 'lbClusterMain',
              path: '/iaas/cluster',
              permission: 'lb_loadbalancerclusters_list',
            },
            {
              title: 'lbClusterNode',
              path: '/iaas/lbagent',
              permission: 'lb_loadbalanceragents_list',
            },
          ],
        },
        {
          title: 'cdn',
          type: 'group',
          children: [
            {
              title: 'cdnDomain',
              path: '/iaas/cdn',
              permission: 'cdn_domains_list',
            },
          ],
        },
      ],
    },
    {
      index: 50,
      title: 'storage',
      icon: 'menu-storage',
      children: [
        {
          title: 'blockStorage',
          type: 'group',
          children: [
            {
              title: 'blockStorage',
              path: '/iaas/blockstorage',
              permission: 'storages_list',
            },
          ],
        },
      ],
    },
  ],
  containerService: [
    {
      index: 30,
      title: 'containerService',
      icon: 'menu-k8s',
      hidden: true,
      children: [
        {
          title: 'workload',
          type: 'group',
          children: [
            {
              title: 'stateless',
              path: '/iaas/k8s-deployment',
              permission: 'k8s_deployments_list',
            },
            {
              title: 'stateful',
              path: '/iaas/k8s-statefulset',
              permission: 'k8s_statefulsets_list',
            },
            {
              title: 'daemonset',
              path: '/iaas/k8s-daemonset',
              permission: 'k8s_daemonsets_list',
            },
            {
              title: 'job',
              path: '/iaas/k8s-job',
              permission: 'k8s_jobs_list',
            },
            {
              title: 'cronjob',
              path: '/iaas/k8s-cronjob',
              permission: 'k8s_cronjobs_list',
            },
            {
              title: 'pod',
              path: '/iaas/k8s-pod',
              permission: 'k8s_pods_list',
            },
            {
              title: 'pvc',
              path: '/iaas/k8s-persistentvolumeclaim',
              permission: 'k8s_persistentvolumeclaims_list',
            },
          ],
        },
        {
          title: 'imageRepo',
          type: 'group',
          children: [
            { title: 'imageRepo', path: '/iaas/k8s-repos', adminOnly: true },
          ],
        },
        {
          title: 'serviceDiscovery',
          type: 'group',
          children: [
            {
              title: 'service',
              path: '/iaas/k8s-service',
              permission: 'k8s_services_list',
            },
            {
              title: 'ingress',
              path: '/iaas/k8s-ingress',
              permission: 'k8s_ingresses_list',
            },
          ],
        },
        {
          title: 'configManage',
          type: 'group',
          children: [
            {
              title: 'configmap',
              path: '/iaas/k8s-configmap',
              permission: 'k8s_configmaps_list',
            },
            {
              title: 'secret',
              path: '/iaas/k8s-secret',
              permission: 'k8s_secrets_list',
            },
          ],
        },
        {
          title: 'clusterManage',
          type: 'group',
          children: [
            {
              title: 'clusterManage',
              path: '/iaas/k8s-cluster',
              permission: 'k8s_kubeclusters_list',
            },
            {
              title: 'node',
              path: '/iaas/k8s-node',
              permission: 'k8s_k8sNode_list',
            },
            {
              title: 'storageClass',
              path: '/iaas/k8s-storageclass',
              permission: 'k8s_storageclasses_list',
            },
            {
              title: 'namespace',
              path: '/iaas/k8s-namespace',
              permission: 'k8s_namespace_list',
            },
            {
              title: 'role',
              path: '/iaas/k8s-rbacrole',
              permission: 'k8s_rbacroles_list',
            },
            {
              title: 'clusterRole',
              path: '/iaas/k8s-rbacclusterrole',
              permission: 'k8s_rbacclusterroles_list',
            },
            {
              title: 'roleBinding',
              path: '/iaas/k8s-rbacrolebinding',
              permission: 'k8s_rbacrolebindings_list',
            },
            {
              title: 'clusterRoleBinding',
              path: '/iaas/k8s-rbacclusterrolebinding',
              permission: 'k8s_rbacclusterrolebindings_list',
            },
            {
              title: 'serviceAccount',
              path: '/iaas/k8s-serviceaccount',
              permission: 'k8s_serviceaccounts_list',
            },
            {
              title: 'kubeComponent',
              path: '/iaas/k8s-kubecomponent',
              permission: 'k8s_kubeclusters_list',
            },
          ],
        },
        {
          title: 'federatedCluster',
          type: 'group',
          children: [
            {
              title: 'federatedNamespace',
              path: '/iaas/k8s-federatednamespace',
              permission: 'k8s_federatednamespaces_list',
            },
            {
              title: 'federatedRole',
              path: '/iaas/k8s-federatedrole',
              permission: 'k8s_federatedroles_list',
            },
            {
              title: 'federatedClusterRole',
              path: '/iaas/k8s-federatedclusterrole',
              permission: 'k8s_federatedclusterroles_list',
            },
            {
              title: 'federatedRoleBinding',
              path: '/iaas/k8s-federatedrolebinding',
              permission: 'k8s_federatedrolebindings_list',
            },
            {
              title: 'federatedClusterRoleBinding',
              path: '/iaas/k8s-federatedclusterrolebinding',
              permission: 'k8s_federatedclusterrolebindings_list',
            },
          ],
        },
      ],
    },
  ],
  ai: [
    {
      index: 55,
      title: 'ml',
      msg: 'nav.catalog.ml',
      icon: 'navbar-view-switch',
      children: navNodesToReactRouteItems(MLOPS_SIDEBAR_NODES),
    },
    {
      index: 57,
      title: 'maasServiceNav',
      msg: 'nav.catalog.maasServiceNav',
      icon: 'res-suggestsalert',
      children: navNodesToReactRouteItems(MAAS_SIDEBAR_NODES),
    },
  ],
  others: [
    {
      index: 65,
      title: 'monitoringAndOperations',
      icon: 'menu-monitor',
      children: [
        {
          title: 'overview',
          type: 'group',
          children: [],
          permission: 'commonalerts_list',
        },
        {
          title: 'resource',
          type: 'group',
          children: [
            {
              title: 'monitorVM',
              path: '/iaas/monitorresources-guest',
              permission: 'monitorresources_list',
            },
            {
              title: 'monitorHost',
              path: '/iaas/monitorresources-host',
              permission: 'monitorresources_list',
            },
          ],
        },
        {
          title: 'monitorMetric',
          type: 'group',
          children: [
            {
              title: 'monitorDashboard',
              path: '/iaas/monitor-dashboard',
              permission: 'unifiedmonitors_get',
            },
            {
              title: 'monitorQuery',
              path: '/iaas/explorer',
              permission: 'unifiedmonitors_get',
            },
          ],
        },
        {
          title: 'alert',
          type: 'group',
          children: [
            {
              title: 'alertPolicy',
              path: '/iaas/commonalerts',
              permission: 'commonalerts_list',
            },
            {
              title: 'alertHistory',
              path: '/iaas/alertrecord',
              permission: 'alertrecords_list,monitorresourcealerts_list',
            },
            {
              title: 'alertResource',
              path: '/iaas/alertresource',
              permission: 'alertresources_list',
            },
            {
              title: 'alertPolicy2',
              path: '/iaas/monitorresourcealerts',
              permission: 'alertrecordshields_list',
            },
          ],
        },
      ],
    },
    {
      index: 91,
      title: 'authenticationAndSecurity',
      icon: 'menu-iam',
      children: [
        {
          title: 'authSystem',
          type: 'group',
          children: [
            { title: 'authIdp', path: '/iaas/idp', permission: 'idps_list' },
            {
              title: 'authDomain',
              path: '/iaas/domain',
              permission: 'domains_list',
            },
            {
              title: 'authProject',
              path: '/iaas/project',
              permission: 'projects_list',
            },
            {
              title: 'authGroup',
              path: '/iaas/group',
              permission: 'groups_list',
            },
            {
              title: 'authUser',
              path: '/iaas/systemuser',
              permission: 'users_list',
            },
            { title: 'authRole', path: '/iaas/role', permission: 'roles_list' },
            {
              title: 'authPolicy',
              path: '/iaas/policy',
              permission: 'policies_list',
            },
          ],
        },
        {
          title: 'securityAlert',
          type: 'group',
          children: [
            {
              title: 'securityAlert',
              path: '/iaas/iam/securityalerts',
              permission: 'notifications_list',
            },
          ],
        },
        {
          title: 'messageCenter',
          type: 'group',
          children: [
            {
              title: 'messageCenter',
              path: '/iaas/notification',
              permission: 'notifications_list',
            },
            {
              title: 'messageSubscribeSetting',
              path: '/iaas/notify-topic',
              permission: 'topics_list',
              adminOnly: true,
            },
            {
              title: 'notifyChannelSetting',
              path: '/iaas/notifyconfig',
              permission: 'notifyconfigs_list',
            },
            {
              title: 'contactManage',
              path: '/iaas/contact',
              permission: 'contacts_list',
            },
            {
              title: 'robotManage',
              path: '/iaas/robot',
              permission: 'robots_list',
            },
          ],
        },
        {
          title: 'systemSetting2',
          type: 'group',
          children: [
            {
              title: 'websiteSetting',
              path: '/iaas/website-configs',
              adminOnly: true,
            },
            {
              title: 'licenseSetting',
              path: '/iaas/license-configs',
              adminOnly: true,
            },
          ],
        },
      ],
    },
    {
      index: 100,
      title: 'feeCenter',
      msg: 'nav.bill.feeCenter',
      icon: 'menu-meter',
      children: navNodesToReactRouteItems(BILL_SIDEBAR_NODES),
    },
  ],
  systemSetting: [
    {
      index: 110,
      title: 'systemSetting',
      icon: 'menu-setting',
      children: [
        {
          title: 'websiteSetting',
          path: '/llm/system/setting',
          adminOnly: true,
        },
      ],
    },
  ],
}
